import { PackingMethodService, PalletService, RackPositionService, UnitcodeService, ZoneService } from '@gtpl/shared-services/masters';
import { WhatsAppNotificationService } from '@gtpl/shared-services/notification-management';
import { SaleOrderService } from '@gtpl/shared-services/sale-management';
import { ForkLiftJobService, FGStockService } from '@gtpl/shared-services/warehouse-management';
import { WhatsappBroadCastService } from '@gtpl/shared-services/whatsapp-broad-cast';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { StoreConsumptionService } from 'libs/shared-services/procurement/src/lib/store-consumption.service';
import { StockInAdapter } from './dto/stock-in.adapter';
import { StockInController } from './stock-in.controller';
import { StockIn } from './stock-in.entity';
import { StockInService } from './stock-in.service';
import { ProductionInventoryService } from '@gtpl/shared-services/production';
import { Stock } from '../stock/stock.entity';

@Module({
  imports: [
    TypeOrmModule.forFeature([StockIn,Stock]),
  ],
  controllers: [StockInController],
  providers: [StockInService,ApplicationExceptionHandler,StockInAdapter,SaleOrderService,FGStockService,PalletService,PackingMethodService,ForkLiftJobService,RackPositionService,ZoneService,WhatsAppNotificationService,WhatsappBroadCastService,StoreConsumptionService,ProductionInventoryService,UnitcodeService]
})
export class StockInModule {}
